import { render } from "./PopupSalaryInfoHistory.vue?vue&type=template&id=cc879e98&scoped=true"
import script from "./PopupSalaryInfoHistory.vue?vue&type=script&lang=js"
export * from "./PopupSalaryInfoHistory.vue?vue&type=script&lang=js"

import "./PopupSalaryInfoHistory.vue?vue&type=style&index=0&id=cc879e98&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc879e98"]])

export default __exports__